import { WEB_EVENT_ICON } from "../constants";
import getFeatures from "./getFeatures";

const getIconType = state => {
  const { [WEB_EVENT_ICON]: iconList = {} } = getFeatures(state);

  return Object.keys(iconList).find(icon => iconList[icon]);
};

export default getIconType;
